module.exports = __webpack_public_path__ + "static/media/ncfx.21e82ab9.svg";